import _get from 'lodash.get';

const isExtractAppStateEnabled = (state, section, template) => {
  if (state && section && template) {
    const extractAppStateSections = _get(
      state,
      `common.siteConfig.extractAppState.sections`,
    );
    const extractAppStateTemplates = _get(
      state,
      `common.siteConfig.extractAppState.templates`,
    );
    return (
      extractAppStateTemplates &&
      extractAppStateTemplates?.includes(template) &&
      extractAppStateSections &&
      extractAppStateSections?.includes(section)
    );
  }
  return undefined;
};

export default isExtractAppStateEnabled;
